module.exports = __webpack_public_path__ + "img/chelsea.08c60101.png";